import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProgramAndParticipantWrapper = styled.div`
  margin-top: 32px;
  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }
  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }
  .header-collapse {
    margin: 16px 16px 16px 16px;
    text-align: end;
  }
  .accordion-header {
    margin: 26px 0px;
  }
  .coach-assignment-container,
  .address-details {
    margin: 24px 16px 24px 16px;

    ${responsive.MOBILE`
      margin: 16px 8px;
    `}
  }
  .program-status {
    margin: 24px 0px 0px 16px;
    ${responsive.MOBILE`
      margin: 16px 8px 0 8px;
    `}
  }
  .participant-tab {
    .header-collapse {
      margin-bottom: 0;
    }
    .MuiPickersTextField-root,
    .MuiPickersInputBase-root {
      width: 100%;
    }

    .participant-accordion {
      margin-top: 16px;
      margin-bottom: 32px;
    }
    .participant-accordion:last-child {
      margin-bottom: 16px;
    }
    .label-style {
      line-height: 22px;
      color: ${COLORS.cirrus_black};
    }
    .value-style {
      line-height: 20px;
      color: ${COLORS.cirrus_black};
    }
  }
`;
